import type { GraphQLError } from "graphql";

export interface GraphQLErrorWithErrorType extends GraphQLError {
  errorType?: string;
}

export function getGraphQLErrors(error: unknown): GraphQLErrorWithErrorType[] {
  const graphQLErrors = (
    error as { graphQLErrors?: readonly GraphQLErrorWithErrorType[] } | null
  )?.graphQLErrors;

  return graphQLErrors ? [...graphQLErrors] : [];
}

export function getGraphQLErrorType(error: unknown): string | undefined {
  return getGraphQLErrors(error).find(({ errorType }) => !!errorType)
    ?.errorType;
}

export function hasGraphQLErrorType(
  error: unknown,
  ...errorTypes: string[]
): boolean {
  return getGraphQLErrors(error).some(
    ({ errorType }) => !!errorType && errorTypes.includes(errorType)
  );
}
